// import { useSetPageTitle } from "src/hooks/useSetPageTitle";
import { useState } from "react";
import { AppLayout } from "src/components/layout/app-layout";
import ManageClientsTab from "./tabs/manage-clients.tab";
import ManageAccountsTab from "./tabs/manage-accounts.tab";
import ManageCampaignsTab from "./tabs/manage-campaigns.tab";

const ClientManagementPage = () => {
  const [searchParams] = useState(() => new URLSearchParams(window.location.search));
  const tab = searchParams.get('tab') || 'manage-clients';
  const validTabs = ['manage-clients', 'manage-accounts', 'manage-campaigns'] as const;
  type TabType = typeof validTabs[number];

  const [activeTab, setActiveTab] = useState<TabType>(
    validTabs.includes(tab as TabType) ? (tab as TabType) : 'manage-clients'
  );
  const performanceTabs = [
    {
      id: 'manage-clients',
      label: 'Clients',
      onClick: () => setActiveTab('manage-clients'),
    },
    {
      id: 'manage-accounts',
      label: 'Accounts',
      onClick: () => setActiveTab('manage-accounts'),
    },
    {
      id: 'manage-campaigns',
      label: 'Campaigns',
      onClick: () => setActiveTab('manage-campaigns'),
    },
  ];

  return (
    <AppLayout
      activePage="/client-management"
      navbarProps={{
        tabs: performanceTabs,
        activeTab: activeTab,
        onTabChange: (tabId: string) => setActiveTab(tabId as 'manage-clients' | 'manage-accounts' | 'manage-campaigns'),
      }}
    >

      <div className="h-[calc(100vh-8rem)]">
        {activeTab === 'manage-clients' && <ManageClientsTab />}
        {activeTab === 'manage-accounts' && <ManageAccountsTab />}
        {activeTab === 'manage-campaigns' && <ManageCampaignsTab />}
      </div>

    </AppLayout>
  );
};

export default ClientManagementPage;
